/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerDownRightIcon16Solid = forwardRef('ArrowDCornerDownRightIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3.25 7c0 .414.336.75.75.75h7.232L8.866 5.384a1.25 1.25 0 1 1 1.768-1.768l3.651 3.652a2.45 2.45 0 0 1 0 3.464l-3.651 3.652a1.25 1.25 0 0 1-1.768-1.768l2.366-2.366H4A3.25 3.25 0 0 1 .75 7V1.25a1.25 1.25 0 1 1 2.5 0V7Z" })));
});
